import type {
    PostPublishSuccessPagePropertyOnboardingContextFieldsV2,
    PostPublishSuccessPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AddNewListingElementPropertyOnboardingManifestV1,
    CompleteNextListingSectionElementPropertyOnboardingManifestV1,
    CompletePublishElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    ManageListingElementPropertyOnboardingManifestV1,
    ViewAllListingsElementPropertyOnboardingManifestV1,
    WhatNextSectionElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    PostPublishSuccessPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyPostPublishSuccessVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/post-publish-success-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const postPublishSuccessBinder = defineBinder(({ webAnalytics, action: { click, reveal, hover } }) => {
    webAnalytics.pageContext<
        PostPublishSuccessPagePropertyOnboardingContextIdsV2,
        PostPublishSuccessPagePropertyOnboardingContextFieldsV2
    >(PostPublishSuccessPagePropertyOnboardingContextManifestV2.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        onboarding_id: BaseContextFieldsMapping.onboarding_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebListYourPropertyPostPublishSuccessVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });

    webAnalytics.observeElement([reveal], WhatNextSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], AddNewListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], ManageListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], CompleteNextListingSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], CompletePublishElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ViewAllListingsElementPropertyOnboardingManifestV1.ids, {});
});
